export function buildCssInlineBase(_props) {
    return `
  p {
    margin: 0;
  }

  h1, h2, h3 {
    margin: 0;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: normal;
  }

  .html-email-body-section-image img {
    width: auto!important;
  }

  ul,
  ol {
    padding: 0;
    list-style-position: inside;
    -webkit-margin-after: 0;
    -webkit-margin-before: 0;
    -webkit-margin-end: 0;
    -webkit-margin-start: 0;
  }

  .html-emails-footer-link {
    text-decoration: none;
  }

  .html-emails-button a {
    display: inline-block;
  }

  li > h1:first-child, li > h2:first-child, li > h3:first-child, li > p:first-child {
    display: inline;
  }`;
}
//# sourceMappingURL=build-css-inline-base.js.map